
import axios from 'axios'

export default {
    getDiscountPriorityList({commit}, params){
        return axios.post('/api/facepay/discount/weight/list', params)
    },
    modifyDiscountPriority({commit}, params){
        return axios.post('/api/facepay/discount/weight/modify', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/priority.js